import { getGlobalLightHub } from "./utils";
import { GlobalLightHub, Page, PageInstance } from "./typing";
import { navigateTo } from "./nav";
import { fetchUrlAndPrefetchAssets } from "./fetch";
import { logger } from "./logger";

export const api = {
    async navigateTo(url: string) {
        return navigateTo(url);
    },
    registerPage(page: PageInstance) {
        const lighthub = getGlobalLightHub();
        const existed = lighthub.pages.find(item => item.id === page.id);
        if (existed) {
            console.warn('Page already resister', existed);
        } else {
            lighthub.pages.push(page);
        }
    },
    exposeGlobal(keys: (string|RegExp)[]) {
        const lighthub = getGlobalLightHub();
        for (let key of keys) {
            if (lighthub.globalExposedKey.indexOf(key) === -1) {
                lighthub.globalExposedKey.push(key);
            }
        }
    },
    ignoreScript(scripts: string[]) {
        const lighthub = getGlobalLightHub();
        for (let key of scripts) {
            if (lighthub.globalIgnoreScript.indexOf(key) === -1) {
                lighthub.globalIgnoreScript.push(key);
            }
        } 
    },
    setIsJSONP(isJSONP: (script: HTMLElement) => boolean) {
        getGlobalLightHub().hooks.isJSONP = isJSONP;
    },
    fetchUrlAndPrefetchAssets: fetchUrlAndPrefetchAssets,

    isInited() {
        const lighthub = getGlobalLightHub();
        if (lighthub && lighthub.inited) {
            return true;
        }
        return false;
    }
}